// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';

import { Alert } from '@mui/material';

// TYPES ---------------------------------------------------------------- //

interface DashboardUnavailableNoticeProps {
  message: string;
  severity?: 'info' | 'warning';
}

// COMPONENT ---------------------------------------------------------------- //

const DashboardUnavailableNotice = ({ message, severity = 'info' }: DashboardUnavailableNoticeProps) => {
  return <Alert severity={severity}>{message}</Alert>;
};

// EXPORT ---------------------------------------------------------------- //

export default DashboardUnavailableNotice;
